import { Directive, OnDestroy, OnInit } from '@angular/core';
import { ContextService } from '@core/services/core/context.service';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[keyboardAttach]',
})
export class KeyboardAttachDirective implements OnInit, OnDestroy {
  private onShowSubscription: Subscription;
  private content: HTMLIonContentElement;
  constructor(private keyboard: Keyboard, private ctx: ContextService) {}

  async ngOnInit() {
    this.content = document.getElementById('keyboardAttachContent') as HTMLIonContentElement;
    if (this.ctx.isApp && this.content) {
      this.content.scrollToBottom();
      this.onShowSubscription = this.keyboard.onKeyboardShow().subscribe(() => this.onShow());
    }
  }

  ngOnDestroy() {
    if (this.onShowSubscription) {
      this.onShowSubscription.unsubscribe();
    }
  }

  private onShow() {
    this.content.scrollToBottom();
  }
}
